import { Currency, PaymentMethodRequest, PaymentMethodType, Pricing } from '@nemuru-eng/js-api-client';

import { CartEntity } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/entities/CartEntity';
import { AbstractConditionsGroup } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/ConditionsGroup/AbstractConditionsGroup';
import { ProviderName } from '@/types/ProviderName';

export type SetupOptions = {
  terms?: number[];
};

export abstract class AbstractPaymentMethod {
  public amount: number | null = null;
  public currency: Currency = Currency.EUR;
  public isSetup: boolean = false;
  public selectedConditionsGroup: AbstractConditionsGroup | null = null;
  public selectedTerm: number | null = null;
  protected abstract ALLOWED_PAYMENT_METHOD_TYPES: PaymentMethodType[];

  constructor(public readonly paymentMethodType: PaymentMethodType, private selected = true) {}

  public abstract setup(amount: number, currency: Currency, opts?: SetupOptions): void;
  public abstract areOptionsConfigurable(): boolean;
  public abstract getAllProviderNames(): ProviderName[];
  public abstract getActiveProviderNames(): ProviderName[];
  public abstract toDto(agentPricings?: Pricing[], cart?: CartEntity): PaymentMethodRequest;

  public toggleSelected(): this {
    this.selected = !this.selected;
    return this;
  }

  public get isSelected(): boolean {
    return this.selected;
  }

  public setSelectedConditionsGroup(conditionsGroup: AbstractConditionsGroup | null): this {
    this.selectedConditionsGroup = conditionsGroup;
    return this;
  }

  public isPaymentMethodTypeAllowed(paymentMethodType: PaymentMethodType): boolean {
    return this.ALLOWED_PAYMENT_METHOD_TYPES.includes(paymentMethodType);
  }
}
